import axios from "axios";
import { API } from "../App";

export async function registerPushNotifications() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    console.log("Push not supported");
    return false;
  }

  try {
    const registration = await navigator.serviceWorker.register("/sw.js");
    await navigator.serviceWorker.ready;

    // Only request permission if already granted or if we can (avoid Safari error)
    const currentPermission = Notification.permission;
    if (currentPermission === "denied") {
      console.log("Notification permission denied");
      return false;
    }

    // If permission not yet decided, don't auto-prompt (requires user gesture on Safari/iOS)
    if (currentPermission === "default") {
      console.log("Push: waiting for user gesture to request permission");
      return false;
    }

    // Get VAPID key from server
    const { data } = await axios.get(`${API}/push/vapid-key`);
    const publicKey = data.public_key;

    if (!publicKey) {
      console.log("No VAPID key");
      return false;
    }

    // Subscribe
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });

    const subJson = subscription.toJSON();

    // Send subscription to backend
    await axios.post(`${API}/push/subscribe`, {
      endpoint: subJson.endpoint,
      keys: subJson.keys,
    });

    console.log("Push subscription active");
    return true;
  } catch (error) {
    console.error("Push registration failed:", error);
    return false;
  }
}

export async function unregisterPushNotifications() {
  try {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) {
      const subscription = await registration.pushManager.getSubscription();
      if (subscription) {
        await axios.post(`${API}/push/unsubscribe`, {
          endpoint: subscription.endpoint,
        });
        await subscription.unsubscribe();
      }
    }
  } catch (error) {
    console.error("Push unregistration failed:", error);
  }
}

export async function requestPushPermission() {
  /**
   * Call this from a user gesture (button click) to request notification permission.
   * Then register the push subscription.
   */
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      return await registerPushNotifications();
    }
    return false;
  } catch (error) {
    console.error("Push permission request failed:", error);
    return false;
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
